import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import AbstractSignupScreen from './AbstractSignupScreen';
import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import UnifiedSignupGradeLevel from '../session-info/UnifiedSignupGradeLevel';
import UnifiedSignupPlan from '../session-info/UnifiedSignupPlan';

export default class PersonaEduConvergeSignupScreen extends AbstractSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-persona-edu-converge';

  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    const ageVerificationField = this.getField(FieldHtmlNameUtil.ageVerification);
    ageVerificationField.componentName = 'hidden-field';
    ageVerificationField.val = 'overage';
    return [
      new UnifiedSignupScreenComponent({
        displayField: ageVerificationField,
      }),
    ];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return [
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.eduLevel),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.ageVerification),
      }),
    ];
  }

  public predicate(): boolean {
    const { gradeLevel, chosenPlan, persona } = this.sessionInfo.value;

    if (gradeLevel) {
      return false;
    }
    if (this.sessionInfo.value.isUnderThirteen) {
      return false;
    }

    if (
      !chosenPlan ||
      !(
        chosenPlan.compareTo(UnifiedSignupPlan.edu) ||
        chosenPlan.compareTo(UnifiedSignupPlan.educator)
      )
    ) {
      return false;
    }

    if (!persona || !persona.isEduPersona()) {
      return false;
    }

    return true;
  }

  public async toNextScreen(): Promise<boolean> {
    const gradeLevel = this.getField(FieldHtmlNameUtil.eduLevel).val;
    this.sessionInfo.value.gradeLevel = UnifiedSignupGradeLevel.fromString(gradeLevel);
    const underAgeVerification = this.getField(FieldHtmlNameUtil.ageVerification).val;
    this.sessionInfo.value.isUnderThirteen = underAgeVerification === 'underage';
    return true;
  }

  public getProgress(): number {
    return 55;
  }
}
